module.exports = __webpack_public_path__ + "images/Network Formation Games.pdf?v=295b3cc1c859b6464fbe07c34290273e";